<template>
  <v-layout row wrap>
    <v-flex xs12 class="position-relative awesomplete-container">
      <textarea
        :ref="autoCompleteRef"
        v-model="text"
        v-validate="`required`"
        data-vv-name="text"
        data-vv-as="texto"
        placeholder="Texto"
        @keydown.enter="avoidEmptyLines($event)"
        :class="{ awesomplete: true, 'has-error': errors.has('text') }"
        data-multiple
        spellcheck="false">
      </textarea>
    </v-flex>
    <v-flex xs12>
      <div>
        <small class="activeClass d-block" id="text-error" v-if="errors.has('text')">
          {{ errors.first('text') }}
        </small>
      </div>
    </v-flex>
  </v-layout>
</template>

<script>
import autoCompleteMixin from '@/mixins/autoComplete';

export default {
  inject: ['$validator'],
  mixins: [
    autoCompleteMixin,
  ],
  props: {
    form: {
      type: Object,
      default: () => {},
    },
    selected: {
      type: Object,
      default: () => {},
    },
    autocompleteList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      text: '',
      maxLengthText: 160,
      autoCompleteRef: 'awesompletesms',
    };
  },
  watch: {
    selected: {
      deep: true,
      immediate: true,
      handler(value) {
        if (value && Object.keys(value).length > 0 && this.text !== value) {
          this.text = value.ivr;
        }
      },
    },
    text(value) {
      this.form.ivr = value;
    },
  },
};
</script>

<style scoped>
  .awesomplete-container >>> .awesomplete {
    min-height: 160px;
  }
</style>


// WEBPACK FOOTER //
// src/components/templateV2/IvrForm.vue